import React from 'react'
import {
  SelectorOptions,
  IconLike,
  AlertBannerSuccess,
  IconHeart,
  SpacerHorizontal,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translator } from 'mage-i18n'

FeedbackSelector.propTypes = {
  value: PropTypes.oneOf(['yes', 'no']),
  onSelect: PropTypes.func,
  t: PropTypes.func
}

function FeedbackSelector({ value, onSelect, t }) {
  return (
    <>
      {value === 'yes' && (
        <>
          <SpacerVertical small />
          <AlertBannerSuccess
            data-browser-test-id="uhqm-feedback-success-message"
            iconType={IconHeart}
            content={t(
              'hqm.feedback.positiveFeedback',
              {},
              'Thank you for the positive feedback, this helps us a lot to provide you with more relevant articles in the future.'
            )}
          />
        </>
      )}
      <div style={{ display: 'flex' }}>
        <SpacerHorizontal large />
        <div style={{ flex: '1 1 auto' }}>
          <SelectorOptions
            onSelect={onSelect}
            options={[
              {
                value: 'yes',
                label: t('hqm.feedback.optionYes', {}, 'Yes, this was helpful'),
                icon: <IconLike color="black" />
              },
              {
                value: 'no',
                label: t('hqm.feedback.optionNo', {}, 'No, I need more help'),
                icon: (
                  <div style={{ transform: 'rotate(180deg)' }}>
                    <IconLike color="black" />
                  </div>
                )
              }
            ]}
            value={value}
          />
        </div>
      </div>
    </>
  )
}

export default connect(state => ({
  t: translator(state)
}))(FeedbackSelector)
